import { Pipe, PipeTransform } from '@angular/core';
import { OrderdirectInvoice } from '../services/orderdirect-invoice/orderdirect-invoice.service';

@Pipe({
    name: 'orderdirectInvoiceStatus',
    standalone: false,
})
export class OrderdirectInvoiceStatusPipe implements PipeTransform {
    transform(invoice: OrderdirectInvoice): 'new' | 'pending' | 'completed' | 'failed' {
        if (invoice.failed_at) {
            return 'failed';
        }

        if (invoice.execute_at && !invoice.afas_ornu) {
            return 'pending';
        }

        if (invoice.afas_ornu) {
            return 'completed';
        }

        return 'new';
    }
}
